import { render, staticRenderFns } from "./SingleUserInput.vue?vue&type=template&id=1adaabef&scoped=true"
import script from "./SingleUserInput.vue?vue&type=script&lang=js"
export * from "./SingleUserInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adaabef",
  null
  
)

export default component.exports